import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { MatTabChangeEvent } from '@angular/material';
import { sla, kpiRelease, quater, year, kpi, slakpidatabase, kpiViewComment} from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { KPIAllHistoryComponent } from './../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-slakpi-database.component',
  templateUrl: './slakpi-database.component.html',
  styleUrls: ['./slakpi-database.component.css']

})
export class SLAKPIDatabaseComponent implements OnInit {
  modalRef: BsModalRef;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  public sli_data: any;
  public slakpiDatabase_data: any;
  public kpiViewComment_data: any;
  public KPIdata: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: number;
  public yearUno?: number;
  public quarterUno?: number;
  public divisionUno?: number;
  public frequencyUno?: number;
  public kpinameSelected: string = '';
  public objkpiRelease: kpiRelease;
  public position_comment: object = { X: 120, Y: 220 };
  public position_appreject: object = { X: 600, Y: 340 };
  public position_history: object = { X: 70, Y: 100 };
  public pageSettings_Justfication: Object;
  public toolbar_Justfication: Object;
  public isback: boolean = false;
  

  @ViewChild('ReminderDialog', { static: false }) ReminderDialog: TemplateRef<any>;
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  //for KPI All Hisory Dialog
  public kpiUnoSelected: number = 0;
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
 

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;

  public commentStartIndex: number = 1;
  public commentMaxCount: number = 100;
  disableMore: boolean = true;
  isStart: boolean = true;
  public isRejectError: boolean = false;
  public txtRejectError: string = '';
  public rejectComment: string = '';
  //public loggined_User: number = 2;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;

  isToggle: boolean = true;
  isPageLoad: boolean = true;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public permision_reminder: boolean = false;

  public userRole: string = '';
  public Qyearsla: number = 0;
  public Qquatersla: number = 0;
  public Qdivisionsla: number = 0;

  isAdmin: boolean = false;
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  //for KPI details
  public kpinameSelectedKpiInfo: string = '';
  public kpiUnoSelectedKpiInfo: number = 0;
  @ViewChild('KPIDetailsHistoryDialog', { static: false }) KPIDetailsHistoryDialog: TemplateRef<any>;
  columnCommentDefinitions: Column[];
    searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
    isDigitalDewa: boolean=false;
    g_previousIndex: any;
    slaName: any;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, public adminService: AdminApiService, private userService: UserService, private router: Router, private modalService: BsModalService, private toaster: ToasterService,
    public utilityService: UtilityService, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIAllHistoryComponent) {

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.Qyearsla = Number(params['yearsla']);
      this.Qquatersla = Number(params['quatersla']);
      this.Qdivisionsla = Number(params['divisionsla']);
      if (this.Qyearsla > 0) this.isback = true;
    });

    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;

    this.userRole = this.user.role;
    this.isAdmin = (this.userRole == 'Administrator' || this.userRole == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      this.permision_reminder = true;
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,
      multiSelect: false,
      
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },
     
    };
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.slaName = this.user.slaname;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.objkpiRelease = new kpiRelease();
     //Get Default Vlaues
    this.loadFilterValues();
    this.loadFrequency();
 
    // setTimeout(() => { this.ResetDialog.hide(); }, 100);
  }


  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("KPI Tracking Sheet");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights
       // this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

        let userPermissionDataRelease = this.userService.getUserRights("Send Reminder");
        if (userPermissionDataRelease != null && userPermissionDataRelease != undefined && userPermissionDataRelease.length > 0) {
          if (userPermissionDataRelease[0].showPage == 1) {
            this.permision_reminder = true;
          }
          else
            this.permision_reminder = false;
        }


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          if (this.Qdivisionsla > 0) {
            this.divisionUno = Number(this.Qdivisionsla);
          }
          this.loadSlaKpiDatabase(2); //by filter

        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
 


  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }

  showPendingUser(userName: any) {
    Swal.fire({
      title: '',
      html: 'KPI is pending with: <br><b>' + userName + '</b><br/>',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
         return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        return;
      }
    })
  }

  // Get slakpi database list
  loadSlaKpiDatabase(condition) {
    
    this.spinner.show();
      this.loading = true;
    let inpValue = new slakpidatabase();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    this.restApi.getSlaKpiDatabase(inpValue)
      .subscribe(data => {
        
        this.slakpiDatabase_data = data;
        this.dataset = data;
        this.dataSearch = data;
        if (this.dataset.length > 0) {
          this.setColnDefn();
        }


        this.loading = false;
        this.spinner.hide();
        this.isPageLoad = false;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;

   
    this.userService.angularGrid = angularGrid;
  }
  onClick(e,es) {
    
   // e.srcElement.className = "active";
    let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row);

    this.highlighSelectedRow(es.row);
    
  }
 

  highlighSelectedRow(SelIndex) {

    this.angularGrid.gridService.highlightRow(this.g_previousIndex, 10);
    let that = this;
    this.angularGrid.gridService.highlightRow(SelIndex, 100000);
    setTimeout(function () {
      that.angularGrid.gridService.highlightRow(SelIndex, 100000);
    }, 300);

    this.g_previousIndex = SelIndex;
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.period && a.period.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.type && a.type.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueText && a.targetValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.actualValueText && a.actualValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.kpiRule && a.kpiRule.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.currentStage && a.currentStage.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpi', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'divisionName', name: 'Division', field: 'divisionName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'period', name: 'Period', field: 'period', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'period', 'period'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'type', name: 'KPI Type', field: 'type', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'actualValueText', name: 'Actual', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        },
        //formatter: (row, cell, val, columnDef, dataContext) => {
        //  if (dataContext.slaRuleUno != 4)
        //    return dataContext.actualValue;
        //  else
        //    return 'Pass';
        //}
      },
      {
        id: 'targetValueText', name: 'Target', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true,
        //formatter: (row, cell, val, columnDef, data) => {
        //  if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
        //    return data.targetValue;
        //  else if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4 && data.bandColour == 'Green')
        //    return 'Pass';
        //  else if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4 && data.bandColour == 'Red')
        //    return 'Fail';
        //  else if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.isNANRNT != '')
        //    return data.isNANRNT;
        //  else if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null))
        //    return '-';
        //},
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        }
      },

      
      {
        id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandValueText', name: 'Performance', field: 'bandValueText', type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'currentStage', name: 'Status', field: 'currentStage', type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0)
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'currentStage', 'currentStage'),
          model: Filters.multipleSelect,
        }
      },

      
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Release-row', titleKey: 'Release_ROW', positionOrder: 62, title: 'Send Reminder',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (data.level3Approved!=1 && this.permision_reminder)
                  return true;
                 else return false;
              },
              iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue ', textCssClass: 'bold',
              action: (e, args) => {
                this.reminderKPI(args.dataContext)

              }
            },

            {
              command: 'Target-row', titleKey: 'Target_ROW', positionOrder: 63, title: 'Pending with',
              iconCssClass: 'fa fa-user-circle fa-lg orange-text ', cssClass: 'orange-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.currentStagePending != 'null' && data.currentStagePending != '')
                  return true;
                else return false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.showPendingUser(data.currentStagePending);
              }
            },
            {
              command: 'Band-row', titleKey: 'Band_ROW', positionOrder: 64, title: 'View Reminder Log',
              iconCssClass: 'fa fa-comment fa-lg ', cssClass: '', textCssClass: 'bold',
            
              action: (e, args) => {
                let data = args.dataContext;
                this.showCommentDialog(data.kpiTrnUno, data.kpiCode, data.kpiName);
              }
            },



            {
              command: 'info-row', titleKey: 'info_ROW', positionOrder: 67, title: 'KPI Info',
              iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIDetails(data.kpiUno, data.kpiName);
              },

            },


          ],
        }
      },
      {
        id: 'currentStagePending', name: 'Whom is pending', field: 'currentStagePending', sortable: false, type: FieldType.string, filterable: false, cssClass: "reallyHidden", headerCssClass: "reallyHidden", width: 0,
        filter: {
          collection: this.uniqueArray(this.dataset, 'currentStagePending', 'currentStagePending'),
          model: Filters.multipleSelect,
        }
      },
    ]


  }


  bandFormatter: Formatter = (row, cell, value, columnDef, data) => {
    if (data.bandColour == '' && (data.isNANRNT != null && data.isNANRNT != ''))
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == 'Red')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (data.bandColour == 'Orange')
      return `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
    if (data.bandColour == 'Yellow')
      return `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
    if (data.bandColour == 'Light Green')
      return `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
    if (data.bandColour == 'Green')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  };


  onSubmitReminder() {
    let comment = this.rejectComment;

    if (comment == '' || comment == null) {
      //Swal.fire('Error', 'Please Enter Comment', 'error')     
      this.txtRejectError = 'Please Enter Comment';
      this.isRejectError = true;
      return false;
    } else {
      this.modalRef.hide();
      this.txtRejectError = '';
      this.isRejectError = false;
      Swal.fire({
        title: '',
        text: 'Please confirm to send the reminder',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          let inpValue = new slakpidatabase();
          inpValue.tenantUno = 1;
          inpValue.userUno = this.login_UserID;
          inpValue.comment = comment;
          inpValue.approver1Exists = this.KPIdata.approver1Exists;
          inpValue.approver2Exists = this.KPIdata.approver2Exists;
          inpValue.approver3Exists = this.KPIdata.approver3Exists;
          inpValue.dataOwnerExists = this.KPIdata.dataOwnerExists;
          inpValue.dataOwnerActionByUno = this.KPIdata.dataOwnerActionByUno;
          inpValue.level1Approved = this.KPIdata.level1Approved;
          inpValue.level2Approved = this.KPIdata.level2Approved;
          inpValue.level3Approved = this.KPIdata.level3Approved;
          inpValue.level1ApproverUno = this.KPIdata.level1ApproverUno;
          inpValue.level2ApproverUno = this.KPIdata.level2ApproverUno;
          inpValue.level3ApproverUno = this.KPIdata.level3ApproverUno;
          inpValue.dataOwnerUno = this.KPIdata.dataOwnerUno;
          inpValue.kpiName = this.KPIdata.kpiName;
          inpValue.kpiTrnUno = this.KPIdata.kpiTrnUno;
          inpValue.kpiUno = this.KPIdata.kpiUno;
          inpValue.kpiyear = this.KPIdata.kpiyear;
          inpValue.kpiquarter = this.KPIdata.kpiquarter;

          this.restApi.sendReminderKPI(inpValue)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
               // Swal.fire('Error', 'Something went wrong', 'error')

                this.toaster.show('error', 'Error', 'Something went wrong.');
              }
              else {
                this.toaster.show('success', 'Success', 'Reminder sent.');
                //Swal.fire({
                //  type: 'success',
                //  title: 'Reminder sent',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.txtRejectError = '';
                this.isRejectError = false;
                // this.loadSlaKpiDatabase(2); //by filter
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.txtRejectError = '';
          this.isRejectError = false;
          return;
        }
      })
    }
    return true;
  }

  reminderKPI(KPIdata1: any) {
    this.KPIdata = KPIdata1;
    this.kpinameSelected = KPIdata1.kpiCode + ' : ' + KPIdata1.kpiName;
    this.rejectComment = '';
    this.txtRejectError = '';
    this.isRejectError = false;
    this.modalRef = this.modalService.show(
      this.ReminderDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  showCommentDialog(kpiTrnUno: any, kpiCode: any, kpiName:any) {    
    this.kpiViewComment_data = [];
    this.commentStartIndex = 1;
    this.kpinameSelected = kpiCode + ' : ' + kpiName;
    this.viewKPIComment(kpiTrnUno);
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-s',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

 
    
  }
  viewKPIComment(kpiTrnUno: any) {
    
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiReminderComments(inpValue)
      .subscribe(data => {

        let objData: any = data;
        if (this.commentStartIndex == 1) {
          this.kpiViewComment_data = [];
          this.kpiViewComment_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewComment_data.push(objData[i]);
          }
        }

        const mockDataset = [];
        for (let i = 0; i < this.kpiViewComment_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            action: 'Reminder Sent',
            postedBy: this.kpiViewComment_data[i].postedBy,
            postedDate: this.kpiViewComment_data[i].postedDate,
            comment: this.kpiViewComment_data[i].comment,
          };
        }
        this.datasetComments = mockDataset;
        this.setCommentDefn();
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }
 
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'action', name: 'Action', field: 'action', sortable: true },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },

    ];
  }
 

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();

  }
  onchangeYear(e) {
    
    this.yearUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeDivision(e) {
    this.divisionUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }


  onSelectedTab() {
    if(!this.isPageLoad)
    this.loadSlaKpiDatabase(2); //by filter
  }

  viewKPIHistoryAll(kpiUno: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }

  backClick() {
    this.router.navigate(['/sladashboard/report'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

  }

  viewKPIDetails(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelectedKpiInfo = kpiUno;
    this.kpinameSelectedKpiInfo = kpiNameEn;
    this.modalRef = this.modalService.show(
      this.KPIDetailsHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
   

  }



}


